import * as React from "react";
import * as ReactDOM from "react-dom";

const imgDir = "./img/item icons/";
const folderDir = {
    bracelet: "bracelet.img/",
    cash: "cash.img/",
    cloth_belt: "cloth_belt.img/",
    cloth_top: "cloth_coat.img/",
    cloth_neck: "cloth_neck.img/",
    cloth_pants: "cloth_pants.img/",
    cloth_shoes: "cloth_shoes.img/",
    consume: "consumption.img/",
    earring: "earrring.img/",
    insignia: "flag.img/",
    heavy_belt: "harmor_belt.img/",
    heavy_top: "harmor_coat.img/",
    heavy_neck: "harmor_neck.img/",
    heavy_pants: "harmor_pants.img/",
    heavy_shoes: "harmor_shoes.img/",
    light_belt: "larmor_belt.img/",
    light_top: "larmor_coat.img/",
    light_neck: "larmor_neck.img/",
    light_pants: "larmor_pants.img/",
    light_shoes: "larmor_shoes.img/",
    leather_belt: "leather_belt.img/",
    leather_top: "leather_coat.img/",
    leather_neck: "leather_neck.img/",
    leather_pants: "leather_pants.img/",
    leather_shoes: "leather_shoes.img/",
    mstone: "magicstone.img/",
    material: "material.img/",
    monstercard: "monstercard_icon.img/",
    necklace: "necklace.img/",
    plate_belt: "plate_belt.img/",
    plate_top: "plate_coat.img/",
    plate_neck: "plate_neck.img/",
    plate_pants: "plate_pants.img/",
    plate_shoes: "plate_shoes.img/",
    ring: "ring.img/",
    subeq: "support.img/",
    ui: "profile_icon.img/",
    skillinfo: "skillexplainicons.img/",
    totem: "totem.img/",
    axe: "axe.img/",
    cross: "cross.img/",
    scythe: "scythe.img/",
    rosary: "rosary.img/",
    dungeon: "dungeons/",
}

export const ImageMap = {
    cash:{
        remys: 4,
        owl: 5,
        candle: 10,
        kaleido: 12,
        cannabread: 162,
        cannamilk: 164,
        cannapudding: 165,
        inven1: 417,
        inven2: 418,
        remysparkling: 778,
        toysparkling: 779,
        amplifier: 884,
        reinforcer: 885,
        transcend: 998,
        extinguisher: 999
    },
    consume:{
        di500: 29,
        lifetoken: 73,
        rein7: 187,
        rein10: 188,
        rein12: 189,
        skinsocket: 313,
        purifier: 317,
        fppot: 355,
        hpheaven: 373,
        mpheaven: 375,
        mirrorbox: 381,
        tele: 396,
        exopotion: 397,
        sacredblessing: 400,
        kiri: 402,
        immortality: 404,
        dailygift: 406,
        mindstim: 434,
        lostpot: 435,
        sectouch: 437,
        eepot: 466,
        pepot: 467,
        ancientpot: 468,
        ref3: 610,
        ref5: 611,
        safeupgrade: 773,
        lvlup: 780,
        alcextract: 790,
        diss: 795,
        enchextract: 801,
        animextract: 806,
        forgottenrepair: 814,
        invenupgrade: 820,
        hellticket: 891,
        antonentry: 929,
        lukeentry: 930,
        vitpot: 975,
        sprpot: 976,
        strpot: 979,
        intpot: 980,
        warlord: 990,
        warlordcry: 991,
        multibooster: 1001,
        vitbooster: 1002,
        magbooster: 1003,
        clones: 1064,
        refiner: 1066,
        timegateorb: 1230,
        powerstationorb: 1231,
        zelvaorb: 1232,
        questclear: 1288,
        ancientticket: 1314,
        pepouch: 1442,
        gddi: 1653,
        featclear: 1666,
        towercert: 1679,
        metroorb: 1943,
        tnornilbead: 1944,
        eldabead: 1946,
        echonticket: 2066,
        earringclear: 2066,
        triftticket: 2094,
        cardbook: 2125,
        mysticpot: 2126,
        utlibrecipe: 2127,
        tlibrecipe: 2128,
        utlibrecipebox: 2129,
        tlibrecipebox: 2130,
        coolant: 2133,
        arenacrowrecipe : 2165,
        arenaformalrecipe : 2166,
        arenaradiantrecipe : 2167,
        arenamilleniumrecipe : 2168,
        arenametallinerecipe : 2169,
        arenashadow : 2170,
        arenalight : 2171,
        arenafire : 2172,
        arenawater : 2173,
        arenaall : 2174,
        tayberrscardbook : 2217,
        harlemorb : 2218,
        quiltrecipe : 2219,
        godbeastssrecipe : 2220,
        devilrecipe : 2221,
        mercilessrecipe : 2222,
        frostrecipe : 2223,
        desirerecipe : 2224,
        dreamrecipe : 2225,
        angelicrecipe : 2226,
        nethermostrecipe : 2227,
        crimerecipe : 2228,
        soulrestrecipe : 2229,
        quiltbox : 2230,
        godbeastssbox : 2231,
        devilbox : 2232,
        mercilessbox : 2233,
        frostbox : 2234,
        desirebox : 2235,
        dreambox : 2236,
        angelicbox : 2237,
        netherbox : 2238,
        crimebox : 2239,
        soulrestbox : 2240,
        skiesbox : 2241,
        seasonsbox : 2242,
        starbox : 2243,
        onslaughtbox : 2244,
        lightbearerbox : 2245,
        radiantbox : 2246,
        azurebox : 2247,
        cyclebox : 2248,
        sirenbox : 2249,
        snakeskewer: 2250,
        radiantrecipe : 2305,
        azurerecipe : 2306,
        cyclerecipe : 2307,
        sirenrecipe : 2308
    },
    material : {
        crystalizedchaos: 222,
        essenceoftherift: 225,
        neotoken: 232,
        goldcube: 293,
        ampprotect: 349,
        ifrag: 364,
        sealdespair: 380,
        pe: 398,
        di: 418,
        dc: 419,
        ee: 422,
        blackmeteor: 427,
        glowingmeteor: 428,
        burningmeteor: 429,
        bluemeteor: 430,
        magtonium: 435,
        reinprotect: 452,
        epicsoul: 456,
        antonium: 550,
        bluerock: 551,
        redrock: 554,
        commonsoul: 564,
        uncommonsoul: 565,
        raresoul: 566,
        uniquesoul: 567,
        legendarysoul: 568,
        epicfrag: 574,
        halifrag1: 576,
        halifrag2: 577,
        halifrag3: 578,
        halifrag4: 579,
        halifrag5: 580,
        halifrag6: 581,
        halifrag7: 582,
        halifrag8: 583,
        halifrag9: 584,
        halifrag10: 585,
        aradmeteor: 586,
        condensedpurity: 595,
        delffrag: 599,
        dfrag: 600,
        antonneuron: 608,
        terranium: 612,
        rterranium: 613,
        lightsource: 614,
        darksource: 615,
        purificationstone: 616,
        bwprotection: 623,
        monolium: 624,
        sealanguish: 626,
        echonA: 632,
        echonB: 633,
        echonC: 634,
        darmasymbol: 637,
        seedbirth: 638,
        ghostface: 639,
        darmamark: 632,
        cata1: 643,
        cata2: 644,
        cata3: 645,
        cata4: 646,
        cata5: 647,
        godlysubstance: 648,
        carbonic: 649,
        carnelian: 650,
        beastrequest: 654,
        tracespecies: 655,
        pioneertoken: 656,
        amfrag: 660,
        delos: 667,
        darksidetoken: 668,
        miscjunk: 672,
        emblemheroes: 673,
        taintedenergy: 674,
        aberrantcrystal: 675,
        aberrantfrag: 676,
        skyfrag: 677,
        skywish: 678,
        riftresponse: 680,
        riftsensor: 681,
        pentacle: 683,
        delusional: 688,
        appeasing: 'q327',
        powerfulenergyblocker: 'q508',
        datachip: 'q523'
    },
    acc : {
        ring: {
            hightech: 40,
            timedefier: 86,
            superstar: 91,
            coldprincess: 144,
            assassin: 145,
            refined: 148,
            greatglory: 173,
            disease: 174,
            giganticpresence: 214,
            infinite: 215,
            eternalglory: 216,
            avarice: 217,
            seagod: 225,
            buriedscream: 227,
            gracia: 228,
            dusky: 229,
            guildfire: 230,
            guildice: 231,
            fish: 237,
            blue: 241,
            sky: 242,
            sense: 243,
            echon: 244,
            heir: 247,
            trine: 248,
            kashipa: 253,
            angelic: 254,
            desire: 255,
            dream: 256,
            radiantone: 257,
            azure: 258
        },
        bracelet: {
            ov2: 35,
            ov3t: 44,
            ov3: 45,
            timedefier: 67,
            superstar: 72,
            bloodcuffs: 96,
            coldprincess: 97,
            pyromancer: 98,
            refined: 101,
            greatglory: 131,
            giganticpresence: 164,
            infinite: 165,
            eternalglory: 166,
            avarice: 167,
            seagod: 173,
            heartrending: 174,
            buriedscream: 175,
            gracia: 176,
            dusky: 177,
            guildfire: 178,
            guildice: 179,
            fish: 185,
            blue: 189,
            sense: 190,
            sky: 191,
            echon: 192,
            heir: 195,
            trine: 196,
            kashipa: 201,
            angelic: 202,
            desire: 203,
            dream: 204,
            radiantone: 205,
            azure: 206
        },
        necklace: {
            ov2: 37,
            ov3t: 48,
            ov3: 49,
            timedefier: 70,
            superstar: 76,
            razor: 104,
            coldprincess: 105,
            butcher: 106,
            refined: 109,
            greatglory: 141,
            disease: 142,
            giganticpresence: 169,
            infinite: 170,
            eternalglory: 171,
            avarice: 172,
            seagod: 181,
            heartrending: 182,
            buriedscream: 183,
            gracia: 184,
            dusky: 185,
            guildfire: 186,
            guildice: 187,
            fish: 193,
            blue: 197,
            sky: 198,
            sense: 199,
            echon: 200,
            heir: 203,
            trine: 204,
            kashipa: 209,
            angelic: 210,
            desire: 211,
            dream: 212,
            radiantone: 213,
            azure: 214
        }
    },
    special: {
        subeq: {
            king: 21,
            ov3t: 47,
            ov3: 48,
            alchtome: 50,
            disscert: 51,
            timetraveler: 146,
            navarre: 147,
            generaltextbook: 148,
            kartelgloves: 154,
            buriedscream: 179,
            dusky: 180,
            ov2: 185,
            quartzspirit: 189,
            onyxspirit: 190,
            infinite: 194,
            eternalglory: 195,
            avarice: 196,
            thorndecoration: 203,
            beckygoggles: 209,
            seagod: 213,
            heartrending: 214,
            gracia: 215,
            disease: 216,
            greatglory: 217,
            manikai: 223,
            fishballline: 225,
            civ: 226,
            bw: 227,
            heblon: 229,
            echon: 230,
            kashipa: 240,
            nether: 241,
            crime: 242,
            soulrest: 243,
            cycle: 244,
            siren: 245
        },
        mstone: {
            ov3t: 36,
            ov3: 37,
            dkt: 124,
            buriedscream: 146,
            dusky: 147,
            ov2: 158,
            infinite: 167,
            eternalglory: 168,
            avarice: 169,
            fireenergy: 175,
            waterenergy: 176,
            lightenergy: 177,
            darkenergy: 178,
            rainbowenergy: 179,
            seagod: 185,
            firewater: 186,
            firelight: 187,
            firedark: 188,
            waterlight: 189,
            waterdark: 190,
            lightdark: 191,
            gracia: 194,
            disease: 195,
            rainbow: 205,
            bismuth: 208,
            jackomemory: 209,
            frostmemory: 210,
            floraememory: 211,
            plutomemory: 212,
            cabalamemory: 213,
            bw: 214,
            civ: 215,
            heblon: 216,
            echon: 217,
            kashipa: 227,
            nether: 228,
            crime: 229,
            soulrest: 230,
            cycle: 231,
            siren: 232
        },
        earring: {
            mseal: 2,
            rainbow: 4,
            brakiumgear: 5,
            silentconstructor: 6,
            bridalpearls: 7,
            bw: 8,
            civ: 9,
            heblon: 10,
            echon: 11,
            schuberte: 12,
            cubesix: 13,
            goldvortex : 14,
            kashipa: 22,
            nether: 23,
            crime: 24,
            soulrest: 25,
            cycle: 26,
            siren: 27
        }
    },
    armour: {
        cloth: {
            belt: {
                darkgothic: 10,
                manaburn: 17,
                eleburn: 18,
                greatglory: 45,
                heartrending: 46,
                buriedscream: 47,
                gracia: 48,
                disease: 49,
                dusky: 50,
                optical: 60,
                crow: 61,
                gespenst: 62,
                echon: 63,
                quilt: 69,
                skies: 70,
                kashipa: 71

            },
            top: {
                darkgothic: 10,
                manaburn: 21,
                eleburn: 22,
                heartrending: 39,
                seagod: 40,
                gracia: 53,
                disease: 54,
                dusky: 55,
                optical: 65,
                crow: 66,
                gespenst: 67,
                echon: 68,
                quilt: 74,
                skies: 75,
                kashipa: 76
            },
            neck: {
                darkgothic: 10,
                manaburn: 17,
                eleburn: 18,
                gracia: 49,
                disease: 50,
                dusky: 51,
                optical: 61,
                crow: 62,
                gespenst: 63,
                echon: 64,
                quilt: 70,
                skies: 71,
                kashipa: 72
            },
            pants: {
                darkgothic: 10,
                manaburn: 19,
                eleburn: 20,
                heartrending: 39,
                seagod: 40,
                gracia: 52,
                disease: 53,
                optical: 64,
                crow: 65,
                gespenst: 66,
                echon: 67,
                quilt: 73,
                skies: 74,
                kashipa: 75
            },
            shoes: {
                darkgothic: 10,
                manaburn: 17,
                eleburn: 18,
                optical: 62,
                crow: 63,
                gespenst: 64,
                echon: 65,
                quilt: 71,
                skies: 72,
                kashipa: 73
            }
        },
        leather: {
            belt: {
                chameleon: 10,
                assassin: 18,
                tactical: 19,
                greatglory: 45,
                heartrending: 46,
                disease: 47,
                gracia: 48,
                buriedscream: 49,
                dusky: 50,
                animal: 60,
                formal: 61,
                fiend: 62,
                echon: 63,
                godbeasts: 69,
                seasons: 70,
                kashipa: 71
            },
            top: {
                chameleon: 10,
                assassin: 22,
                tactical: 23,
                heartrending: 40,
                seagod: 41,
                greatglory: 50,
                buriedscream: 51,
                gracia: 52,
                disease: 53,
                dusky: 54,
                animal: 64,
                formal: 65,
                fiend: 66,
                echon: 67,
                godbeasts: 73,
                seasons: 74,
                kashipa: 75
            },
            neck: {
                chameleon: 10,
                assassin: 17,
                tactical: 18,
                greatglory: 43,
                heartrending: 44,
                buriedscream: 45,
                gracia: 46,
                disease: 47,
                dusky: 48,
                animal: 58,
                formal: 59,
                fiend: 60,
                echon: 61,
                godbeasts: 67,
                seasons: 68,
                kashipa: 69
            },
            pants: {
                chameleon: 10,
                assassin: 18,
                tactical: 19,
                heartrending: 37,
                seagod: 38,
                greatglory: 47,
                buriedscream: 48,
                gracia: 49,
                disease: 50,
                animal: 61,
                formal: 62,
                fiend: 63,
                echon: 64,
                godbeasts: 70,
                seasons: 71,
                kashipa: 72
            },
            shoes: {
                chameleon: 10,
                assassin: 17,
                tactical: 18,
                heartrending: 36,
                greatglory: 48,
                buriedscream: 49,
                gracia: 50,
                disease: 51,
                dusky: 52,
                animal: 62,
                formal: 63,
                fiend: 64,
                godbeasts: 71,
                seasons: 72,
                kashipa: 73
            }
        },
        light: {
            belt: {
                subvolc: 10,
                natural: 17,
                football: 18,
                seagod: 35,
                greatglory: 45,
                heartrending: 46,
                buriedscream: 47,
                gracia: 48,
                disease: 49,
                dusky: 50,
                skeletal: 60,
                radiant: 61,
                supercontinent: 62,
                echon: 63,
                devil: 69,
                star: 70,
                kashipa: 71
            },
            top: {
                subvolc: 10,
                natural: 21,
                football: 22,
                heartrending: 38,
                seagod: 39,
                greatglory: 50,
                buriedscream: 51,
                gracia: 52,
                disease: 53,
                dusky: 54,
                skeletal: 64,
                radiant: 65,
                supercontinent: 66,
                echon: 67,
                devil: 73,
                star: 74,
                kashipa: 75
            },
            neck: {
                subvolc: 10,
                natural: 17,
                football: 18,
                seagod: 35,
                heartrending: 47,
                buriedscream: 48,
                gracia: 49,
                disease: 50,
                dusky: 51,
                skeletal: 61,
                radiant: 62,
                supercontinent: 63,
                echon: 64,
                devil: 70,
                star: 71,
                kashipa: 72
            },
            pants: {
                subvolc: 10,
                natural: 19,
                football: 20,
                seagod: 38,
                greatglory: 49,
                buriedscream: 50,
                gracia: 51,
                disease: 52,
                dusky: 53,
                skeletal: 63,
                radiant: 64,
                supercontinent: 65,
                echon: 66,
                devil: 72,
                star: 73,
                kashipa: 74
            },
            shoes: {
                subvolc: 10,
                natural: 17,
                football: 18,
                heartrending: 35,
                seagod: 36,
                greatglory: 47,
                buriedscream: 48,
                gracia: 49,
                disease: 50,
                dusky: 51,
                skeletal: 61,
                radiant: 62,
                supercontinent: 63,
                echon: 64,
                devil: 70,
                star: 71,
                kashipa: 72
            }
        },
        heavy: {
            belt: {
                darkhole: 10,
                contract: 18,
                spiderqueen: 19,
                seagod: 36,
                greatglory: 46,
                heartrending: 47,
                buriedscream: 48,
                gracia: 49,
                disease: 50,
                dusky: 51,
                nuclear: 61,
                millenium: 62,
                naga: 63,
                echon: 64,
                merciless: 70,
                onslaught: 71,
                kashipa: 72
            },
            top: {
                darkhole: 10,
                contract: 20,
                spiderqueen: 21,
                heartrending: 38,
                seagod: 39,
                greatglory: 51,
                buriedscream: 52,
                gracia: 53,
                disease: 54,
                dusky: 55,
                nuclear: 65,
                millenium: 66,
                naga: 67,
                echon: 68,
                merciless: 74,
                onslaught: 75,
                kashipa: 76
            },
            neck: {
                darkhole: 10,
                contract: 18,
                spiderqueen: 19,
                seagod: 36,
                greatglory: 46,
                heartrending: 47,
                buriedscream: 48,
                gracia: 49,
                disease: 50,
                dusky: 51,
                nuclear: 61,
                millenium: 62,
                naga: 63,
                echon: 64,
                merciless: 70,
                onslaught: 71,
                kashipa: 72
            },
            pants: {
                darkhole: 10,
                contract: 18,
                spiderqueen: 19,
                heartrending: 37,
                seagod: 38,
                greatglory: 49,
                buriedscream: 50,
                gracia: 51,
                disease: 52,
                dusky: 53,
                nuclear: 63,
                millenium: 64,
                naga: 65,
                echon: 66,
                merciless: 72,
                onslaught: 73,
                kashipa: 74
            },
            shoes: {
                darkhole: 10,
                contract: 17,
                spiderqueen: 18,
                heartrending: 35,
                seagod: 36,
                greatglory: 45,
                buriedscream: 46,
                gracia: 47,
                disease: 48,
                dusky: 49,
                nuclear: 59,
                millenium: 60,
                naga: 61,
                echon: 62,
                merciless: 68,
                onslaught: 69,
                kashipa: 70
            }
        },
        plate: {
            belt: {
                infrequiem: 10,
                manavortex: 17,
                fullplate: 18,
                seagod: 34,
                greatglory: 43,
                heartrending: 44,
                buriedscream: 45,
                gracia: 46,
                disease: 47,
                dusky: 48,
                gemstone: 58,
                metalline: 59,
                sevensins: 60,
                echon: 61,
                frost: 67,
                lightbearer: 68,
                kashipa: 69
            },
            top: {
                infrequiem: 10,
                manavortex: 21,
                fullplate: 22,
                heartrending: 39,
                seagod: 40,
                halidom85: 49,
                greatglory: 51,
                buriedscream: 52,
                gracia: 53,
                disease: 54,
                dusky: 55,
                gemstone: 65,
                metalline: 66,
                sevensins: 67,
                echon: 68,
                frost: 74,
                lightbearer: 75,
                kashipa: 76
            },
            neck: {
                infrequiem: 10,
                manavortex: 17,
                fullplate: 18,
                seagod: 35,
                greatglory: 44,
                heartrending: 45,
                buriedscream: 46,
                gracia: 47,
                disease: 48,
                dusky: 49,
                gemstone: 59,
                metalline: 60,
                sevensins: 61,
                echon: 62,
                frost: 68,
                lightbearer: 69,
                kashipa: 70
            },
            pants: {
                infrequiem: 10,
                manavortex: 18,
                fullplate: 19,
                seagod: 37,
                greatglory: 48,
                buriedscream: 49,
                gracia: 50,
                disease: 51,
                dusky: 52,
                gemstone: 62,
                metalline: 63,
                sevensins: 64,
                echon: 65,
                frost: 71,
                lightbearer: 72,
                kashipa: 73
            },
            shoes: {
                infrequiem: 10,
                manavortex: 17,
                fullplate: 18,
                heartrending: 36,
                seagod: 37,
                greatglory: 46,
                buriedscream: 47,
                gracia: 48,
                disease: 49,
                dusky: 50,
                gemstone: 60,
                metalline: 61,
                sevensins: 62,
                echon: 63,
                frost: 69,
                lightbearer: 70,
                kashipa: 71
            }
        }
    },
    ui: {
        hp: 0,
        mp: 1,
        str: 2,
        int: 3,
        vit: 4,
        spr: 5,
        patk: 6,
        matk: 7,
        iatk: 30,
        pdef: 8,
        mdef: 9,
        pcrit: 10,
        mcrit: 11,
        aspd: 12,
        cspd: 13,
        mspd: 14,
        exo: 15,
        hrate: 16,
        eva: 17,
        hprec: 18,
        mprec: 19,
        immo: 20,
        hrec: 21,
        fire: 22,
        fireR: 23,
        water: 24,
        waterR: 25,
        light: 26,
        lightR: 27,
        shadow: 28,
        shadowR: 29
    },
    skillinfo: {
        cubeSkill: 0,
        abnormalSkill: 1,
        physicalSkill: 2,
        magicalSkill: 3,
        hitSkill: 4,
        grabSkill: 5,
        attackgGrabSkill: 6,
        fixedSkill: 7,
        percentSkill: 8,
        healSkill: 9,
        buffSkill: 10,
        elementalSkill: 11,
        realtimeSkill: 14
    },
    weapon:{
        totem:{
            glory: 134,
            triumph: 133,
            sky: 164,
            harlem: 165,
            emancipation: 166,
            neoprem: 168
        },
        axe: {
            glory: 129,
            triumph: 128,
            sky: 159,
            harlem: 160,
            emancipation: 161,
            neoprem: 163
        },
        scythe:{
            glory: 127,
            triumph: 126,
            sky: 154,
            harlem: 155,
            emancipation: 156,
            neoprem: 158
        },
        rosary:{
            glory: 119,
            triumph: 118,
            sky: 143,
            harlem: 144,
            emancipation: 145,
            neoprem: 147
        },
        cross:{
            glory: 126,
            triumph: 125,
            sky: 151,
            harlem: 152,
            emancipation: 153,
            neoprem: 155
        }
    }
}

export function imgResolver(imgName : string): string{
    // Check each of these categories and pull the first img that matches (names should be unique)
    var nonGearCategories = ['cash', 'material', 'consume', 'ui', 'skillinfo'];
    for (var category of nonGearCategories){
        if (ImageMap[category][imgName] !== undefined)
            return imgDir + folderDir[category] + ImageMap[category][imgName] + ".png";
    }

    return imgDir + "missing.png";
}

export function armourImgResolver(type : string, slot: string, imgName : string): string{
    // Check if we have an index for this image
    if (ImageMap['armour'][type][slot][imgName] !== undefined)
        return imgDir + folderDir[type + "_" + slot] + ImageMap['armour'][type][slot][imgName] + ".png";
    else
        return imgDir + "missing.png";
}

export function equipImgResolver(type : string, slot: string, imgName : string): string{
    // Check if we have an index for this image
    if (ImageMap[type][slot][imgName] !== undefined)
        return imgDir + folderDir[slot] + ImageMap[type][slot][imgName] + ".png";
    else
        return imgDir + "missing.png";
}
export function weaponImgResolver(slot: string, imgName : string): string{
    // Check if we have an index for this image
    if (ImageMap['weapon'][slot][imgName] !== undefined)
        return imgDir + folderDir[slot] + ImageMap['weapon'][slot][imgName] + ".png";
    else
        return imgDir + "missing.png";
}

export function imgSS(imgName){
    return <img src={"./img/screenshots/"+(imgName)+".png"}/>;
}

export function img(imgName){
    return <img src={imgResolver(imgName)}/>;
}

export function imgArmour(type : string, slot: string, imgName : string){
    return <img src={armourImgResolver(type, slot, imgName)}/>;
}

export function imgEquip(type : string, slot: string, imgName : string){
    return <img src={equipImgResolver(type, slot, imgName)}/>;
}
export function imgWeapon(slot: string, imgName : string){
    return <img src={weaponImgResolver(slot, imgName)}/>;
}
export function imgDungeon(imgName : string){
    return <img src={imgDir + folderDir.dungeon + (imgName) + ".png"}/>;
}


/*
        <img src={Img.imgResolver("candle")}/>
        <img src={Img.imgResolver("hp")}/>
        <img src={Img.imgResolver("hellticket")}/>
        <img src={Img.armourImgResolver("light", "belt", "natural")}/>
        <img src={Img.armourImgResolver("light", "top", "natural")}/>
        <img src={Img.armourImgResolver("light", "pants", "natural")}/>
        <img src={Img.armourImgResolver("light", "neck", "natural")}/>
        <img src={Img.armourImgResolver("light", "shoes", "natural")}/>
        <img src={Img.equipImgResolver("acc", "necklace", "sky")}/>
        <img src={Img.equipImgResolver("acc", "ring", "sky")}/>
        <img src={Img.equipImgResolver("acc", "bracelet", "sky")}/>
        <img src={Img.equipImgResolver("special", "mstone", "civ")}/>
        <img src={Img.equipImgResolver("special", "subeq", "civ")}/>
        <img src={Img.equipImgResolver("special", "earring", "civ")}/>
}*/